import AgentSearch from './component';
export default AgentSearch;
